import { Box } from "@mantine/core";
import type { LockablePagePermission } from "./pageCopy";
import { LOCKABLE_PAGE_PREVIEW } from "./pagePreview";
import classes from "./GatePreview.module.css";

type GatePreviewProps = {
  pageKey: LockablePagePermission;
};

/**
 * Fundo desfocado do bloqueio: prévia estática da página bloqueada (título,
 * ação, três números e uma lista), com a marcação e os dados de exemplo do
 * protótipo Atendimento.dc.html. Nunca a página real: montá-la dispararia as
 * rotas que respondem 403. Decorativa: `aria-hidden` e nada focável.
 */
export function GatePreview({ pageKey }: GatePreviewProps) {
  const { title, sub, cta, stats, rows } = LOCKABLE_PAGE_PREVIEW[pageKey];

  return (
    <Box
      className={classes.preview}
      aria-hidden
      data-testid="feature-gate-preview">
      <Box className={classes.header}>
        <Box className={classes.heading}>
          <Box className={classes.title}>{title}</Box>
          <Box className={classes.sub}>{sub}</Box>
        </Box>
        <Box className={classes.cta}>{cta}</Box>
      </Box>
      <Box className={classes.stats}>
        {stats.map((stat) => (
          <Box
            key={stat.label}
            className={classes.stat}>
            <Box className={classes.statLabel}>{stat.label}</Box>
            <Box className={classes.statValue}>{stat.value}</Box>
          </Box>
        ))}
      </Box>
      <Box className={classes.list}>
        {rows.map((row) => (
          <Box
            key={row.title}
            className={classes.row}>
            <Box className={classes.avatar} />
            <Box className={classes.rowText}>
              <Box className={classes.rowTitle}>{row.title}</Box>
              <Box className={classes.rowMeta}>{row.meta}</Box>
            </Box>
            <Box className={classes.tag}>{row.tag}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
